import BaseService from '../base-service';
import NetworkUrls from '../network-urls';

class LangService extends BaseService {
  async getTexts() {
    const config = {
      url: NetworkUrls.langTexts,
      method: 'GET',
    };

    return this._exec(config, false);
  }
}

export const langService = new LangService();



// WEBPACK FOOTER //
// ./src/network/services/lang.service.js